module.exports = __webpack_public_path__ + "img/avatar3.022e1523.png";